(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["paperloops-happy-financial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('paperloops-happy-page')) {
  customElements.define('paperloops-happy-page', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const link = target?.closest('a');
        if (!link) return;
        if (link.getAttribute('href') === '#h3-trial-faq') {
          const details = this.querySelector('#h3-trial-faq');
          if (details) details.open = true;
        }
        const placement = link.dataset.h3Track;
        if (!placement) return;
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'paperloops_happy_financial_click', placement });
        } catch (error) {}
        try {
          if (typeof window.Shopify?.analytics?.publish === 'function') {
            window.Shopify.analytics.publish('paperloops_happy_financial_click', { placement });
          }
        } catch (error) {}
      }, { signal: this.abortController.signal });
      const sticky = this.querySelector('.hf-mobile-cta');
      const hero = this.querySelector('.hf-hero');
      const chairs = this.querySelector('.hf-chairs');
      const final = this.querySelector('.hf-final');
      if (sticky && hero && chairs && final && 'IntersectionObserver' in window) {
        let pastHero = false;
        let chairsVisible = false;
        let pastFinal = false;
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === hero) pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            if (entry.target === chairs) chairsVisible = entry.isIntersecting;
            if (entry.target === final) pastFinal = entry.isIntersecting || entry.boundingClientRect.bottom < 0;
          });
          sticky.hidden = !pastHero || chairsVisible || pastFinal;
        }, { threshold: 0 });
        [hero, chairs, final].forEach((element) => this.observer.observe(element));
      }
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paperloops-header-v4"]) return;
  try {
    
(()=>{
  const initialize=section=>{
    const header=section.querySelector('[data-pl5]');
    if(!header||header.dataset.ready)return;
    header.dataset.ready='true';
    const abort=new AbortController(),signal=abort.signal;
    const items=Array.from(header.querySelectorAll('[data-pl5-item]'));
    const scrim=header.querySelector('[data-pl5-scrim]');
    const mobile=section.querySelector('[data-pl5-mobile]');
    const mobileOpen=header.querySelector('[data-pl5-mobile-open]');
    const desktop=window.matchMedia('(min-width:1180px)');
    const fine=window.matchMedia('(hover:hover) and (pointer:fine)');
    let active=null,openTimer=0,closeTimer=0,previousOverflow='';
    const position=()=>{if(active)header.style.setProperty('--pl5-bottom',Math.max(0,header.getBoundingClientRect().bottom)+'px')};
    const clearTimers=()=>{window.clearTimeout(openTimer);window.clearTimeout(closeTimer)};
    const close=(restore=false)=>{
      clearTimers();
      if(!active)return;
      const button=active.querySelector('[data-pl5-toggle]');
      active.querySelector('[data-pl5-panel]').hidden=true;
      button.setAttribute('aria-expanded','false');
      if(scrim)scrim.hidden=true;
      active=null;
      if(restore)button.focus();
    };
    const open=item=>{
      clearTimers();if(!desktop.matches)return;
      if(active===item)return;
      close();active=item;position();
      item.querySelector('[data-pl5-panel]').hidden=false;
      item.querySelector('[data-pl5-toggle]').setAttribute('aria-expanded','true');
      if(scrim)scrim.hidden=false;
    };
    items.forEach(item=>{
      const button=item.querySelector('[data-pl5-toggle]');
      button.addEventListener('click',()=>active===item?close():open(item),{signal});
      item.querySelector('.pl5__pair').addEventListener('keydown',event=>{if(event.key==='ArrowDown'){event.preventDefault();open(item);item.querySelector('[data-pl5-panel] a')?.focus()}},{signal});
      item.addEventListener('pointerenter',()=>{if(fine.matches){clearTimers();openTimer=window.setTimeout(()=>open(item),180)}},{signal});
      item.addEventListener('pointerleave',()=>{window.clearTimeout(openTimer);if(fine.matches&&!item.contains(document.activeElement))closeTimer=window.setTimeout(()=>{if(active===item)close()},220)},{signal});
    });
    document.addEventListener('pointerdown',event=>{if(active&&!active.contains(event.target))close()},{signal});
    document.addEventListener('focusin',event=>{if(active&&!active.contains(event.target))close()},{signal});
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&active){event.preventDefault();close(true)}},{signal});
    window.addEventListener('scroll',position,{passive:true,signal});
    window.addEventListener('resize',position,{passive:true,signal});
    const closeMobile=()=>{if(mobile?.open)mobile.close()};
    mobileOpen?.addEventListener('click',()=>{close();previousOverflow=document.documentElement.style.overflow;mobile.showModal();document.documentElement.style.overflow='hidden';mobileOpen.setAttribute('aria-expanded','true');mobile.querySelector('[data-pl5-mobile-close]').focus()},{signal});
    mobile?.querySelector('[data-pl5-mobile-close]')?.addEventListener('click',closeMobile,{signal});
    mobile?.addEventListener('click',event=>{if(event.target===mobile){const bounds=mobile.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)closeMobile()}},{signal});
    mobile?.addEventListener('close',()=>{document.documentElement.style.overflow=previousOverflow;mobileOpen?.setAttribute('aria-expanded','false');if(!desktop.matches)mobileOpen?.focus()},{signal});
    mobile?.querySelectorAll('[data-pl5-mobile-toggle]').forEach(button=>button.addEventListener('click',()=>{
      const panel=document.getElementById(button.getAttribute('aria-controls')),expand=button.getAttribute('aria-expanded')!=='true';
      mobile.querySelectorAll('[data-pl5-mobile-toggle]').forEach(other=>{other.setAttribute('aria-expanded','false');document.getElementById(other.getAttribute('aria-controls')).hidden=true});
      button.setAttribute('aria-expanded',String(expand));panel.hidden=!expand;
    },{signal}));
    mobile?.querySelector('[data-pl5-language]')?.addEventListener('change',event=>event.target.form.requestSubmit(),{signal});
    mobile?.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeMobile,{signal}));
    desktop.addEventListener('change',()=>{close();closeMobile()},{signal});
    header.querySelector('[data-pl5-cart]')?.addEventListener('click',event=>{if(window.shtCartDrawer&&typeof window.shtCartDrawer.openDrawer==='function'){close();try{window.shtCartDrawer.openDrawer(event.currentTarget);event.preventDefault()}catch(error){}}},{signal});
    const unload=event=>{if(event.target===section){close();closeMobile();abort.abort();document.removeEventListener('shopify:section:unload',unload)}};
    document.addEventListener('shopify:section:unload',unload);
  };
  document.querySelectorAll('[data-pl5]').forEach(header=>initialize(header.closest('.shopify-section')));
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paperloops-office-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-office-page]');
  if (!root || root.dataset.officeBound) return;
  root.dataset.officeBound = '1';
  const form = root.querySelector('#OfficeDesignForm');
  const target = root.querySelector('#office-design-request');
  const bar = root.querySelector('[data-office-sticky]');
  const storageKey = 'paperloops_office_request';
  const sourceKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const params = new URLSearchParams(window.location.search);
  const sources = {};
  sourceKeys.forEach(key => {
    const value = params.get(key);
    if (!value || !form) return;
    sources[key] = value.slice(0,160);
    const field = document.createElement('input');
    field.type = 'hidden'; field.name = 'contact[' + key + ']'; field.setAttribute('value', sources[key]);
    form.appendChild(field);
  });
  const publish = (name, values) => {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, values);
    }
  };
  document.querySelectorAll('[data-office-cta]').forEach(link => {
    link.addEventListener('click', event => {
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      target.focus({preventScroll:true});
      publish('paperloops_office_cta', {placement:link.dataset.officeCta});
    });
  });
  if (form) {
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      const reference = 'office-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2,8);
      const field = form.querySelector('[data-office-reference]');
      if (field) field.value = reference;
      try { sessionStorage.setItem(storageKey, JSON.stringify({reference, sources, at:Date.now()})); } catch (error) {}
    });
  }
  const success = root.querySelector('[data-office-success]');
  if (success) {
    if (bar) bar.hidden = true;
    success.focus({preventScroll:true});
    target.scrollIntoView({block:'start'});
    try {
      const raw = sessionStorage.getItem(storageKey);
      const pending = raw ? JSON.parse(raw) : null;
      sessionStorage.removeItem(storageKey);
      if (pending && Date.now() - pending.at < 3600000) publish('paperloops_office_lead', {request_reference:pending.reference,...pending.sources});
    } catch (error) {}
  } else if (bar && target && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => {bar.hidden = entries[0].isIntersecting;}, {threshold:0}).observe(target);
  }
  const errors = root.querySelector('[data-office-errors]');
  if (errors) { errors.focus({preventScroll:true}); target.scrollIntoView({block:'start'}); }
})();

  } catch(e) { console.error(e); }
})();
})();
